import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  UseModalProps,
} from "@chakra-ui/modal";
import { ModalBody, ThemingProps } from "@chakra-ui/react";
import React, { useCallback, useRef } from "react";
import { MemberFilterQueryForm } from "../../forms/MemberFilterQueryForm";
import { useAdminApiClient } from "../../hooks/useApiClient";
import { useToast } from "../../hooks/useToast";

interface MemberFilterQueryModalProps {
  isOpen: boolean;
  memberQueryFilter: string;
  businessId: string;
  onSuccess: (query?: string) => void;
  onClose: () => void;
}

export const MemberFilterQueryModal = ({
  isOpen,
  memberQueryFilter,
  businessId,
  onSuccess,
  onClose,
  ...modalProps
}: MemberFilterQueryModalProps & UseModalProps & ThemingProps<"Modal">) => {
  const initialFocusRef = useRef<HTMLInputElement>(null);
  const { showErrorToast } = useToast();
  const apiClient = useAdminApiClient();

  const onFailure = useCallback(() => {
    showErrorToast("Failed to create member filter query.");
  }, [showErrorToast]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      initialFocusRef={initialFocusRef}
      {...modalProps}
    >
      <ModalOverlay></ModalOverlay>
      <ModalContent>
        <ModalContent>
          <ModalHeader>Member Filter Query</ModalHeader>
          <ModalBody>
            <MemberFilterQueryForm
              apiClient={apiClient}
              businessId={businessId}
              query={memberQueryFilter}
              onSuccess={onSuccess}
              onCancel={onClose}
            />
          </ModalBody>
        </ModalContent>
      </ModalContent>
    </Modal>
  );
};
